import type { Repub } from '@cx-modules/constants';

export const SHOW_MARKETING_CONSENT_CONFIG: Record<Repub, boolean> = {
  AU: false,
  BR: false,
  CA: false,
  CO: false,
  CX: false,
  DE: false,
  DK: false,
  ES: false,
  FR: false,
  GZ: true,
  IN: false,
  IT: true,
  KE: false,
  MX: false,
  NG: false,
  NL: false,
  NZ: false,
  OC: true,
  PT: false,
  SE: false,
  SM: false,
  US: false,
  WS: true,
  XX: false,
  ZA: false,
};
